import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cmsServices } from 'features/cms/services/cms.service';

import { toast } from 'react-hot-toast';

export const useCreateCmsPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (cmsData) => cmsServices.addCmsPage(cmsData),
    onSuccess: () => {
      queryClient.invalidateQueries(['cmsPages']);
      toast.success('CMS page created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to create CMS page');
    },
  });
};

export const useUpdateCmsPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ cmsId, cmsData }) => cmsServices.updateCmsPage({ cmsId, cmsData }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['cmsPages']);
      queryClient.invalidateQueries(['cmsPages', variables.cmsId]);
      toast.success('CMS page updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update CMS page');
    },
  });
};

export const useDeleteCmsPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (cmsId) => cmsServices.deleteCmsPage(cmsId),
    onSuccess: () => {
      queryClient.invalidateQueries(['cmsPages']);
      toast.success('CMS page deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete CMS page');
    },
  });
};